import { colors, customEvent, GOI_PLATFORM_URL, VStack } from "goi_common";
import { useRouter } from "next/router";
import { PARLOR_FAMILY_MAIN_PATH } from "../constants/event";
import { useGoiCall } from "@/hooks/useGoiCall";

export const MissParlorDetailBottomFixedModal = () => {
  const router = useRouter();
  const { id } = router.query as { id?: string };
  const { goiCall } = useGoiCall();

  return (
    <div
      css={{
        position: "fixed",
        right: "12px",
        bottom: "20px",
        zIndex: 200,
      }}
    >
      <div
        css={{
          width: "132px",
          height: "150px",
          borderRadius: "10px",
          boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.18)",
          background: colors.white,
          padding: "4px",
        }}
      >
        <VStack gap={4}>
          <button
            onClick={() => {
              router.push(`${GOI_PLATFORM_URL}/match/parlor-requests/${id}/`);
              customEvent({
                newGtm: {
                  path: PARLOR_FAMILY_MAIN_PATH,
                  trigger_and_target: "footer-uv_mtch_rqst_prlr",
                },
              });
            }}
            className="subtitle_14_b"
            css={{
              borderRadius: "6px",
              background: "#F7CB72",
              padding: "9px 0",
              width: "100%",
            }}
          >
            장례 비용 견적
          </button>

          <button
            onClick={() => {
              customEvent({
                newGtm: {
                  path: PARLOR_FAMILY_MAIN_PATH,
                  trigger_and_target: "footer_goi_call",
                },
              });

              goiCall();
            }}
            className="subtitle_14_b"
            css={{
              borderRadius: "6px",
              background: "#F7CB72",
              padding: "9px 0",
              width: "100%",
            }}
          >
            전화 상담
          </button>
        </VStack>
        <div
          className="caption_12_b"
          css={{
            padding: "24px 0",
            textAlign: "center",
          }}
        >
          (주)고이장례연구소
        </div>
      </div>
    </div>
  );
};
